import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({
    onlyShowNormalCrop,
    onlyShowCoverCrop,
    onlyShowGalleryCrop,
    defaultThumbnail,
    ...args
  }) {
    super(args)
    this.children = [
      {
        ...this.getComponentWithVModel('image-input'),
        props: {
          onlyShowNormalCrop,
          onlyShowCoverCrop,
          onlyShowGalleryCrop,
          defaultThumbnail
        }
      }
    ]
  }
}
